import { Link } from "react-router-dom";
import { ArrowUpRight, Plus } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/motion";

export default function DeepIncludes({ data }) {
  return (
    <div className="mt-16" data-testid="deep-includes">
      <Reveal>
        <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-ink">{data.title}</h2>
        <p className="mt-4 max-w-2xl text-base sm:text-lg leading-relaxed text-body" data-testid="deep-includes-statement">
          {data.statement}
        </p>
        <Link
          to={data.linkTo}
          data-testid="deep-view-oneoff-link"
          className="mt-6 inline-flex items-center gap-2 rounded-full border border-blue px-6 py-3 font-mono text-[11px] uppercase tracking-[0.15em] text-blue transition-colors hover:bg-blue hover:text-canvas"
        >
          {data.linkLabel} <ArrowUpRight size={14} />
        </Link>
      </Reveal>

      <Reveal className="mt-12">
        <div className="rounded-3xl bg-blue-midnight p-7 sm:p-12 text-canvas">
          <Eyebrow className="text-sage">Deep Cleaning</Eyebrow>
          <p className="mt-3 font-serif text-2xl sm:text-3xl tracking-tight" data-testid="deep-plus-label">{data.plusLabel}</p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2">
            {data.sections.map((sec) => (
              <div key={sec.title} className="rounded-2xl border border-blue-border bg-blue-card p-7" data-testid={`deep-section-${sec.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <h3 className="font-sans text-lg font-semibold">{sec.title}</h3>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-sage">Additional Deep Cleaning</p>
                <ul className="mt-5 space-y-2.5">
                  {sec.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm sm:text-base text-canvas/85">
                      <Plus size={15} className="mt-1 shrink-0 text-sage" /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </Reveal>

      <Reveal className="mt-8">
        <p className="rounded-2xl border border-sage/40 bg-sage-light/50 p-6 text-sm leading-relaxed text-body" data-testid="deep-charges-note">
          {data.chargesNote}
        </p>
      </Reveal>
    </div>
  );
}
